<div class='image-loader-builder-container' [formGroup]='formGroup'>
	<div class='component-container'>
		<div class='component'>
			<div class='draggable-icon-wrapper' cdkDrag>
				<mat-icon class='component-icon'>drag_indicator</mat-icon>
			</div>
			<div class='component-icon-wrapper'>
				<mat-icon class='component-icon'>{{iconName}}</mat-icon>
			</div>
			<div class='component-input' [formGroup]='titlesFormGroup'>
				<mat-form-field class='form__row-input' appearance='fill'>
					<mat-label> Title
					</mat-label>
					<input matInput formControlName='English' required>
					<mat-error
						*ngIf='titlesFormGroup.controls.English.touched && titlesFormGroup.controls.English.invalid'>
						<span *ngIf='titlesFormGroup.controls.English.errors.required'>Required field</span>
						<span *ngIf='titlesFormGroup.controls.English.errors.maxlength'>Max length - 400 char</span>
					</mat-error>
				</mat-form-field>
			</div>
			<div class='option-actions'>
				<mat-icon class='icon' (click)='openMultiLanguageDialog(titlesFormGroup,"input","Title")'>language
				</mat-icon>
			</div>
		</div>
		<div class='remove-container'>
			<mat-icon class='icon' (click)='remove(0)'>delete</mat-icon>
		</div>
	</div>
	<ng-container *ngFor='let productFormGroup of variantsControls; let i = index'>
		<div class='component-container' [formGroup]='productFormGroup'>
			<div style='width: 100%;'>
				<div class='component'>
					<div class='draggable-icon-wrapper'></div>
					<div class='component-icon-wrapper empty'></div>
					<div class='component-input'
						 [ngStyle]="{'border-bottom':productFormGroup.controls.pictureUrl.touched && productFormGroup.controls.pictureUrl.invalid ? '2px solid #fc8276' : 'inherit'}">
						<cactussoft-uploader [uploaderType]='uploaderType'
											 [initialImage]="{image: productFormGroup.controls['pictureUrl'].value, title: 'Image'}"
											 (uploadSource)='uploadPicture($event,productFormGroup)'></cactussoft-uploader>
						<div class='option-actions' style='padding-top: 0;'>
							<mat-icon class='icon' *ngIf='i!== 0' (click)='remove(i)'>delete</mat-icon>
						</div>
					</div>
				</div>
				<div class='picture-validation-message'
					 *ngIf='productFormGroup.controls.pictureUrl.touched && productFormGroup.controls.pictureUrl.invalid'>
					<span>Picture required</span>
				</div>
				<div class='component input-fields'>
					<div class='component-input' [formGroup]='productFormGroup.controls.names'>
						<mat-form-field class='form__row-input' appearance='fill'>
							<mat-label> Product name
							</mat-label>
							<input matInput formControlName='English' required>
							<mat-error
								*ngIf='productFormGroup.controls.names.controls.English.touched && productFormGroup.controls.names.controls.English.invalid'>
								<span *ngIf='productFormGroup.controls.names.controls.English.errors.required'>Required field</span>
								<span *ngIf='productFormGroup.controls.names.controls.English.errors.maxlength'> Max length - 400 char</span>
							</mat-error>
						</mat-form-field>
						<div class='option-actions'>
							<mat-icon class='icon'
									  (click)='openMultiLanguageDialog(productFormGroup.controls.names,"input", "Product name")'>
								language
							</mat-icon>
						</div>
					</div>
					<div class='component-input' [formGroup]='productFormGroup.controls.infos'>
						<mat-form-field class='form__row-input' appearance='fill'>
							<mat-label> Product info
							</mat-label>
							<input matInput formControlName='English'>
							<mat-error
								*ngIf='productFormGroup.controls.infos.controls.English.touched && productFormGroup.controls.infos.controls.English.invalid'>
								<span *ngIf='productFormGroup.controls.infos.controls.English.errors.maxlength'> Max length - 200 char</span>
							</mat-error>
						</mat-form-field>
						<div class='option-actions'>
							<mat-icon class='icon'
									  (click)='openMultiLanguageDialog(productFormGroup.controls.infos,"input", "Product info")'>
								language
							</mat-icon>
						</div>
					</div>
					<div class='component-input'>
						<mat-form-field appearance='fill'>
							<mat-label> Price
							</mat-label>
							<input matInput formControlName='value' [imask]="maskConfig" [unmask]="'typed'" required>
							<mat-error
								*ngIf='productFormGroup.controls.value.touched && productFormGroup.controls.value.invalid'>
								<span *ngIf='productFormGroup.controls.value.errors.required'>Required field</span>
								<span
									*ngIf='productFormGroup.controls.value.errors.maxlength'> Max length - 400 char</span>
							</mat-error>
						</mat-form-field>
					</div>
				</div>
			</div>
		</div>
	</ng-container>
	<span class='add-variant-label' (click)='addFormControl()'>+ Add Product</span>
	<div class="required-checkbox-container">
		<cactussoft-required-checkbox [formGroup]="formGroup"></cactussoft-required-checkbox>
	</div>
</div>
